
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteOe as ObiOwnShipRemoteOeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-oe.js';
 
 
 

 
 export const ObiOwnShipRemoteOe = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-oe',
   elementClass: ObiOwnShipRemoteOeElement,
   events: {
     
   }
  });
 
 